"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectDestructuringEmpty"));

var _dialog = require("@package/dialog");

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function SuccessDialog(_ref) {
  (0, _objectDestructuringEmpty2["default"])(_ref);
  var dispatch = (0, _reactRedux.useDispatch)();
  var iconClassName = (0, _classnames["default"])(_defaultModule["default"]['icon'], 'icon-success');

  function handleCloseDialog() {
    dispatch((0, _dialog.closeDialog)());
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['success']
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: iconClassName
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['headline']
  }, "\u0412\u044B\u043F\u043B\u0430\u0442\u044B \u0441\u043E\u0437\u0434\u0430\u043D\u044B", /*#__PURE__*/_react["default"].createElement("br", null), "\u0443\u0441\u043F\u0435\u0448\u043D\u043E"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['note']
  }, "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0441\u0442\u0430\u0442\u0443\u0441 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435", /*#__PURE__*/_react["default"].createElement("br", null), "\u0432 \u0440\u0430\u0437\u0434\u0435\u043B\u0435 ", /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    className: _defaultModule["default"]['link'],
    to: process.env['PUBLIC_URL'] + '/operations/payouts',
    onClick: function onClick() {
      return handleCloseDialog();
    }
  }, "\xAB\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u0438\xBB")));
}

var _default = SuccessDialog;
exports["default"] = _default;